import React, { useContext } from 'react';
import {
  Button, Col, Container, Row,
} from 'reactstrap';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '../../../utils/hooks/mediaQuery.hook';
import TextTruncate from '../../../components/TextTruncate';
import { HEADER_IMAGE_DIMENSIONS, HEADER_IMAGE_SM_DIMENSIONS } from '../constants';
import { CampaignContext } from '../../../context/CampaignWrapper';
import ImageContainer from '../../../components/ImageContainer';
import ICampaignHeader from '../interfaces/ICampaignHeader';

import { ReactComponent as TrophyIcon } from '../../../assets/icons/trophy.svg';

const CampaignHeader = ({ openScoreboardModal } : ICampaignHeader) => {
  const {
    campaign: {
      name, headerImgUrl, textConfig, showScoreboard,
    },
  } = useContext(CampaignContext);
  const [translate] = useTranslation();
  const { isMobile } = useMediaQuery();

  const info = textConfig?.info;

  const containerStyle = isMobile
    ? { background: 'var(--bs-light)' }
    : { background: 'linear-gradient(to right, white 35%, var(--bs-light) 0%)' };

  const imageClassName = isMobile ? '' : 'rounded';
  const imageDimensions = isMobile ? HEADER_IMAGE_SM_DIMENSIONS : HEADER_IMAGE_DIMENSIONS;
  const cloudinaryParams = ['c_limit'];

  const iconStyle = { verticalAlign: 'bottom' };

  const HeaderImage = headerImgUrl ? (
    <ImageContainer
      src={headerImgUrl}
      alt={name}
      className={imageClassName}
      size={imageDimensions}
      params={cloudinaryParams}
      skeletonType="header-image"
    />
  ) : (
    <div className="campaign-header-placeholder" style={imageDimensions}>
      {name}
    </div>
  );

  return (
    <div className="py-md-5" style={containerStyle}>
      <Container>
        <Row>
          <Col xs={12} md="6" className="p-0 p-sm-3 text-center">
            {HeaderImage}
          </Col>
          <Col xs={12} md={6} className="align-self-center">
            <div className="py-3 px-md-3">
              {headerImgUrl && (
                <h2 className="fw-bold text-center text-md-start">{name}</h2>
              )}
              <div className="campaign-header-description">
                <TextTruncate text={info} />
              </div>
              <hr />
              {showScoreboard && (
                <Button color="link" className="p-0 text-decoration-none fw-normal" onClick={openScoreboardModal}>
                  <TrophyIcon style={iconStyle} />
                  {' '}
                  {translate('COMPONENTS.CAMPAIGN_HEADER.SCOREBOARD')}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CampaignHeader;
